
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_524_2167)"}},[_c('path',{attrs:{"d":"M10.454 2.5H7.965c0-1.103-.893-2-1.991-2a1.998 1.998 0 00-1.991 2h-2.49C.67 2.5 0 3.172 0 4v11c0 .828.669 1.5 1.494 1.5h8.96c.825 0 1.494-.672 1.494-1.5V4c0-.828-.669-1.5-1.494-1.5zM2.987 13.75A.747.747 0 012.24 13a.747.747 0 111.494 0c0 .416-.333.75-.747.75zm0-3A.747.747 0 012.24 10a.747.747 0 111.494 0c0 .416-.333.75-.747.75zm0-3A.747.747 0 012.24 7a.747.747 0 111.494 0c0 .416-.333.75-.747.75zm2.987-6c.414 0 .747.334.747.75a.747.747 0 11-1.494 0c0-.416.333-.75.747-.75zm3.983 11.5a.25.25 0 01-.25.25h-4.48a.25.25 0 01-.249-.25v-.5a.25.25 0 01.25-.25h4.48a.25.25 0 01.249.25v.5zm0-3a.25.25 0 01-.25.25h-4.48a.25.25 0 01-.249-.25v-.5a.25.25 0 01.25-.25h4.48a.25.25 0 01.249.25v.5zm0-3a.25.25 0 01-.25.25h-4.48a.25.25 0 01-.249-.25v-.5a.25.25 0 01.25-.25h4.48a.25.25 0 01.249.25v.5z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_524_2167"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(0 .5)","d":"M0 0h11.948v16H0z"}})])])])
          )
        }
      }
    